import axios, { AxiosError, AxiosHeaders } from 'axios'
import z from 'zod'
import { getAccessToken } from '@reward-platform/auth0-m2m'
import { JRTAPIException } from '@reward-platform/shared-api/exceptions/JRTAPIException'
import { MissingEnvVariableException } from '@reward-platform/shared-api/exceptions/MissingEnvVariableException'

import { LocationsSearchApiHeaders, LocationsSearchApiHeadersSchema } from './schemas/location.api'

export const getBaseUrl = () => {
  const safeParseEnv = z.string().nonempty().url().safeParse(process.env.API_BASE_ENDPOINT)

  if (!safeParseEnv.success) {
    throw new MissingEnvVariableException('API_BASE_ENDPOINT')
  }

  return new URL(`${safeParseEnv.data}/v1`).toString()
}

export const createHeaders = async (params: LocationsSearchApiHeaders) => {
  const { opCo, correlationId, userId, searchEngine } =
    LocationsSearchApiHeadersSchema.parse(params)
  const token = await getAccessToken(opCo)
  const headers = new AxiosHeaders()
  headers.set('Content-Type', 'application/json')
  headers.set('Authorization', `Bearer ${token}`)

  if (correlationId) {
    headers.set('X-Correlation-ID', correlationId)
  }
  if (userId) {
    headers.set('X-User-ID', userId)
  }
  if (searchEngine) {
    headers['X-Search-Engine'] = searchEngine
  }

  return headers
}

export const createClient = async (headers: LocationsSearchApiHeaders) => {
  const requestHeaders = await createHeaders(headers)
  const axiosConfig = {
    headers: {
      ...requestHeaders,
    },
  }

  const baseUrl = getBaseUrl()
  const client = axios.create({ baseURL: baseUrl, ...axiosConfig })

  client.interceptors.response.use(
    (response) => response,
    (error: AxiosError | Error) => {
      if (axios.isAxiosError(error)) {
        throw new JRTAPIException(error as any)
      }
    }
  )
  return client
}
